module.exports = __webpack_public_path__ + "static/media/etalogo_login.ce1b4d6d.png";